<p-breadcrumb [model]="routePath"></p-breadcrumb>
<div appAccessProvider [accessCode]="{ menuCode: 'INVOICES', pageCode: 'ALL' }">
  <app-module-header [showImportExportBtn]="showImportExportBtn" [hideAuditBtn] = "false" [showLastSync]="false"></app-module-header>
</div>
<div appAccessProvider [accessCode]="{ menuCode: 'INVOICES', pageCode: 'ALL', subPageCode: 'LIST' }">
    <p-tabView [(activeIndex)]="activeIndex" [scrollable]="true">
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="{{miIcons.DASHBOARD_ACTIVITY_FEED}} inline-block wh-14 mr-2 relative"></i>
                <span [ngClass]="{'active-tab-label': activeIndex === 0, 'inactive-tab-label': activeIndex !== 0}"
                    class="tab-label" translate>lbl_all</span>&nbsp;<span class="iconNumber text-color-secondary">({{
                    totalRecords ? totalRecords : 0 }})</span>
            </ng-template>
            <ng-template pTemplate="body">
               <app-mi-table
                [collectionOfColumns]="allColumns"
                [attributeLabels]="filterAttributeLabels"
                [data]="tableData"
                [uniqueId]="uniqueId"
                [isLoading]="isLoading"
                (onPageChange)="onPageChange($event)"
                (itemPerPageChange)="itemPerPageChange($event)"
                [totalRecords]="totalRecords"
                [itemsPerPage]="itemsPerPage"
                [filterList]="filterList"
                (onValueChange)="onFilterValueChange($event)"
                [filterFields]="filterFieldsArray"
                [label]="btnLabel"
                [bulkUpdateLabel]="bulkUpdateLabel"
                [bulkDeleteLabel]="bulkDeleteLabel"
                [attributeData]="attributeData"
                (onSearchValueChange)="onSearchValueChanges($event)"
                [rowItems]="rowItems"
                [bulkSelectionsItems] = "bulkSelectionsItems"
                (setCurrentRowData)="setCurrentRowData($event)"
                (onClickInvoiceDownload)="onClickInvoiceDownload($event)"
                [visible]="visible"
                [btnUpdate]="btnUpdate"
                (onSortData)="onSortData($event)"          
                [isEntity]="isEntity"
                [staticEntity]="'sponsor_invoices'"
                >
                </app-mi-table>
            </ng-template>
        </p-tabPanel>
    
    </p-tabView>
</div>